import {
  BooleanInput,
  DeleteWithConfirmButton,
  Edit,
  NumberInput,
  ReferenceField,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  required,
  useRecordContext
} from 'react-admin';
import { Box } from '@mui/material';
import { formatUTCDate } from '../../util/formatDate';

const Title = () => {
  const record = useRecordContext();
  return <span>{record ? `Edit Army: ${record.name}` : 'Edit Army'}</span>;
};

const CustomToolbar = () => (
  <Toolbar>
    <Box display="flex" justifyContent="space-between" width="100%">
      <SaveButton />
      <DeleteWithConfirmButton
        mutationMode="undoable"
        confirmTitle="Confirm Deletion"
        confirmContent="Are you sure you want to delete this record? This action cannot be undone."
      />
    </Box>
  </Toolbar>
);

const ArmyEdit = () => {
  return (
    <Edit title={<Title />}>
      <SimpleForm toolbar={<CustomToolbar />}>
        <TextInput source="id" disabled />
        <TextInput source="name" validate={required()} />
        <TextInput source="general" validate={required()} />
        <TextInput source="soldiers" />
        <NumberInput source="node" validate={required()} />
        <TextInput source="faction" validate={required()} />
        <TextInput source="country" validate={required()} />
        <TextInput source="status" validate={required()} />
        <BooleanInput source="walls" />
        <BooleanInput source="recruitment" />
        <BooleanInput source="unsure" />
        <TextInput source="comment" multiline />
        <ReferenceField source="added_by.id" reference="users">
          <TextInput source="username" label="Added by" disabled />
        </ReferenceField>
        <TextInput
          source="added_date"
          label="Date Added (UTC)"
          format={(value) => formatUTCDate(value)}
          disabled
        />
        <ReferenceField source="updated_by.id" reference="users">
          <TextInput source="username" label="Updated by" disabled />
        </ReferenceField>
        <TextInput
          source="updated_date"
          label="Updated date (UTC)"
          format={(value) => formatUTCDate(value)}
          disabled />
      </SimpleForm>
    </Edit>
  );
};

export default ArmyEdit;
